import { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import Navbar from '../home/components/Navbar';
import FloatingWhatsApp from '../home/components/FloatingWhatsApp';

const WHATSAPP_URL =
  'https://wa.me/905301714669?text=Merhaba%20SARA%20KUYUMCULUK%2C%20%C3%B6zel%20bir%20tasar%C4%B1m%20talep%20etmek%20istiyorum.';

const faqs = [
  {
    q: 'Hazır ürünleriniz var mı yoksa sadece özel tasarım mı yapıyorsunuz?',
    a: 'Sadece kişiye özel tasarım üretiyoruz. Hazır ürün stoğumuz bulunmamaktadır. Her parça, sipariş üzerine ve müşterinin isteklerine göre özel olarak tasarlanır ve üretilir.',
  },
  {
    q: 'Tasarım süreci ne kadar sürüyor?',
    a: 'Tasarımın karmaşıklığına bağlı olarak ortalama 3-7 gün içinde taslağı hazırlayıp size sunuyoruz. Onay sonrası üretim süreci genellikle 7-14 gün arasında tamamlanır. Toplam süreç ortalama 2-3 haftadır.',
  },
  {
    q: 'Hangi metallerde çalışıyorsunuz?',
    a: 'Altın (14 ayar, 18 ayar, 22 ayar) ve gümüş (925 ayar) ile çalışıyoruz. Tercih ettiğiniz metal ve renk (sarı altın, beyaz altın, rose altın) hakkında tasarım aşamasında karar verebilirsiniz.',
  },
  {
    q: 'Fiyatlandırma nasıl yapılıyor?',
    a: 'Fiyat, kullanılan metalin gramajına, tasarımın karmaşıklığına ve ek detaylara (taş, işleme vb.) göre değişir. Taslak onayı öncesinde net bir fiyat teklifi sunuyoruz. Böylece sürpriz bir maliyetle karşılaşmazsınız.',
  },
  {
    q: 'Tasarımı beğenmezsem ne olur?',
    a: 'Taslağı size gönderdikten sonra beğenmediğiniz noktaları belirtmeniz yeterli. Revizyon taleplerinizi ücretsiz olarak değerlendiriyoruz. Tasarımdan tamamen memnun olmadan üretime geçmiyoruz.',
  },
  {
    q: 'Ödeme nasıl yapılıyor?',
    a: 'Tasarım onayı sonrası %50 kapora alınır. Kalan tutar ürün tesliminden önce tamamlanır. Ödeme seçenekleri hakkında WhatsApp üzerinden detaylı bilgi alabilirsiniz.',
  },
  {
    q: 'Kargo ve teslimat süreci nasıl işliyor?',
    a: 'Ürünlerimiz sigortalı kargo ile gönderilir. Türkiye içi teslimat ortalama 1-3 iş günü sürer. Her ürün özel hediye kutusunda ve koruyucu ambalajda hazırlanır.',
  },
  {
    q: 'İsim kolye veya harf kolye yaptırabilir miyim?',
    a: 'Evet, isim kolye, harf kolye, tarih yazılı bileklik ve benzeri kişiselleştirilmiş tasarımlar en popüler ürünlerimiz arasındadır. Yazı fontu, boyut ve stil tamamen size özel ayarlanır.',
  },
  {
    q: 'Hediye olarak sipariş verebilir miyim?',
    a: 'Kesinlikle! Birçok müşterimiz sevdikleri için anlamlı hediyeler tasarlıyor. Özel hediye kutusu ve not kartı ekleyebiliriz. Alıcıya teslimat adresi farklı olabilir.',
  },
  {
    q: 'Tasarım fikrim var ama nasıl anlatacağımı bilmiyorum. Yardımcı olur musunuz?',
    a: 'Elbette! WhatsApp üzerinden bize ulaştığınızda, size doğru soruları sorarak hayalinizdeki tasarımı birlikte şekillendiriyoruz. Referans görseller, Pinterest panoları veya basit çizimler bile bize çok yardımcı olur.',
  },
];

export default function FAQPage() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);

  useEffect(() => {
    document.title = 'Sıkça Sorulan Sorular – Sara Kuyumculuk';
    window.scrollTo(0, 0);
  }, []);

  return (
    <main className="bg-luxury-black min-h-screen overflow-x-hidden">
      <Navbar />

      {/* Hero */}
      <section className="relative pt-32 pb-16 md:pt-40 md:pb-24 px-6 md:px-12">
        <div className="max-w-4xl mx-auto text-center">
          <p className="text-gold text-xs tracking-[0.3em] uppercase mb-4 font-sans">
            Yardım Merkezi
          </p>
          <h1 className="font-serif text-4xl md:text-6xl text-white leading-tight mb-6">
            Sıkça Sorulan Sorular
          </h1>
          <p className="text-white/50 text-base md:text-lg max-w-2xl mx-auto leading-relaxed font-sans">
            Aklınızdaki soruların cevaplarını burada bulabilirsiniz. Daha fazla
            bilgi için WhatsApp üzerinden bize ulaşabilirsiniz.
          </p>
        </div>
      </section>

      {/* FAQ Accordion */}
      <section className="py-8 md:py-16 px-6 md:px-12">
        <div className="max-w-3xl mx-auto">
          <div className="space-y-4">
            {faqs.map((faq, i) => (
              <div
                key={i}
                className="border border-luxury-border rounded-lg overflow-hidden"
              >
                <button
                  onClick={() => setOpenIndex(openIndex === i ? null : i)}
                  className="w-full flex items-center justify-between p-5 md:p-6 text-left cursor-pointer hover:bg-luxury-surface/50 transition-colors"
                >
                  <span className="font-serif text-base md:text-lg text-white pr-4">
                    {faq.q}
                  </span>
                  <div className="w-8 h-8 flex items-center justify-center flex-shrink-0">
                    <i
                      className={`ri-${openIndex === i ? 'subtract' : 'add'}-line text-gold text-lg transition-transform duration-300`}
                    />
                  </div>
                </button>
                <div
                  className={`overflow-hidden transition-all duration-500 ${openIndex === i ? 'max-h-96' : 'max-h-0'}`}
                >
                  <div className="px-5 md:px-6 pb-5 md:pb-6">
                    <p className="text-white/50 text-sm md:text-base leading-relaxed font-sans">
                      {faq.a}
                    </p>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Still Have Questions */}
      <section className="py-16 md:py-24 px-6 md:px-12 bg-luxury-surface">
        <div className="max-w-3xl mx-auto text-center">
          <div className="w-16 h-16 flex items-center justify-center mx-auto mb-6 border border-gold/30 rounded-full">
            <i className="ri-question-mark text-gold text-2xl" />
          </div>
          <h2 className="font-serif text-3xl md:text-4xl text-white mb-4">
            Hala Sorularınız Var mı?
          </h2>
          <p className="text-white/50 text-base md:text-lg mb-10 font-sans">
            Cevabını bulamadığınız bir sorunuz mu var? WhatsApp üzerinden doğrudan
            bize ulaşabilirsiniz. Size en kısa sürede dönüş yapacağız.
          </p>
          <a
            href={WHATSAPP_URL}
            target="_blank"
            rel="nofollow noreferrer"
            className="btn-gold inline-block px-10 py-4 text-sm rounded-sm whitespace-nowrap"
          >
            WhatsApp&apos;tan Yaz
          </a>
        </div>
      </section>

      {/* Footer */}
      <footer className="bg-luxury-black border-t border-luxury-border py-12 px-6 md:px-12">
        <div className="max-w-6xl mx-auto">
          <div className="grid grid-cols-1 md:grid-cols-4 gap-10 mb-10">
            <div>
              <img
                src="https://public.readdy.ai/ai/img_res/1dc01291-9518-472c-8814-2fd5a6290899.png"
                alt="Sara Kuyumculuk"
                className="h-8 w-auto object-contain mb-4"
              />
              <p className="text-white/40 text-sm font-sans leading-relaxed">
                Kişiye özel altın ve gümüş tasarımlar. Her parça, bir hikaye.
              </p>
            </div>
            <div>
              <h4 className="text-white text-sm font-sans mb-4 tracking-wide">
                Sayfalar
              </h4>
              <div className="flex flex-col gap-2">
                <Link
                  to="/"
                  className="text-white/40 hover:text-gold text-sm transition-colors"
                >
                  Ana Sayfa
                </Link>
                <Link
                  to="/hakkimizda"
                  className="text-white/40 hover:text-gold text-sm transition-colors"
                >
                  Hakkımızda
                </Link>
                <Link
                  to="/sss"
                  className="text-white/40 hover:text-gold text-sm transition-colors"
                >
                  Sıkça Sorulan Sorular
                </Link>
              </div>
            </div>
            <div>
              <h4 className="text-white text-sm font-sans mb-4 tracking-wide">
                İletişim
              </h4>
              <div className="flex flex-col gap-2">
                <a
                  href={WHATSAPP_URL}
                  target="_blank"
                  rel="nofollow noreferrer"
                  className="text-white/40 hover:text-gold text-sm transition-colors"
                >
                  WhatsApp: +90 530 171 4669
                </a>
                <span className="text-white/40 text-sm">Türkiye</span>
              </div>
            </div>
            <div>
              <h4 className="text-white text-sm font-sans mb-4 tracking-wide">
                Sosyal Medya
              </h4>
              <div className="flex flex-col gap-2">
                <a
                  href="https://www.instagram.com/sara.kuyumculuk"
                  target="_blank"
                  rel="nofollow noreferrer"
                  className="text-white/40 hover:text-gold text-sm transition-colors inline-flex items-center gap-2"
                >
                  <span className="w-5 h-5 flex items-center justify-center">
                    <i className="ri-instagram-line" />
                  </span>
                  Instagram
                </a>
              </div>
            </div>
          </div>
          <div className="border-t border-luxury-border pt-6 text-center">
            <p className="text-white/30 text-xs font-sans">
              &copy; {new Date().getFullYear()} Sara Kuyumculuk. Tüm hakları
              saklıdır.
            </p>
          </div>
        </div>
      </footer>

      <FloatingWhatsApp />
    </main>
  );
}